function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-two-tiles\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.52,14.9H5.22a1.13,1.13,0,0,1,0-2.25h10.3a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.52,18.49H5.22a1.13,1.13,0,0,1,0-2.25h10.3a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3,33.07H4.44a3.2,3.2,0,0,1-3.2-3.19V10.12a3.2,3.2,0,0,1,3.2-3.19H16.3a3.2,3.2,0,0,1,3.2,3.19V29.88A3.2,3.2,0,0,1,16.3,33.07ZM4.44,9.18a1,1,0,0,0-1,.94V29.88a1,1,0,0,0,1,.94H16.3a1,1,0,0,0,.95-.94V10.12a1,1,0,0,0-.95-.94Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.26,27.55H8.48a2.92,2.92,0,1,1,0-5.83h3.78a2.92,2.92,0,1,1,0,5.83ZM8.48,24a.67.67,0,1,0,0,1.33h3.78a.67.67,0,1,0,0-1.33Z",
  fill: "#231f20"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.78,14.9H24.48a1.13,1.13,0,0,1,0-2.25h10.3a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.78,18.49H24.48a1.13,1.13,0,0,1,0-2.25h10.3a1.13,1.13,0,0,1,0,2.25Z",
  fill: "#231f20"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M35.56,33.07H23.7a3.2,3.2,0,0,1-3.2-3.19V10.12a3.2,3.2,0,0,1,3.2-3.19H35.56a3.2,3.2,0,0,1,3.2,3.19V29.88A3.2,3.2,0,0,1,35.56,33.07ZM23.7,9.18a1,1,0,0,0-.95.94V29.88a1,1,0,0,0,.95.94H35.56a1,1,0,0,0,.95-.94V10.12a1,1,0,0,0-.95-.94Z",
  fill: "#231f20"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31.52,27.55H27.74a2.92,2.92,0,1,1,0-5.83h3.78a2.92,2.92,0,1,1,0,5.83ZM27.74,24a.67.67,0,1,0,0,1.33h3.78a.67.67,0,1,0,0-1.33Z",
  fill: "#231f20"
});

function SvgCmsTwoTiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

export default SvgCmsTwoTiles;